'use client';

import {
  Cable,
  Download,
  DraftingCompass,
  HardDrive,
  type LucideIcon,
  MessagesSquare,
  Shapes,
  Share2,
  FolderOpen,
} from 'lucide-react';
import { useLocale, useTranslations } from 'next-intl';
import { useMemo } from 'react';

import { getDrivesCopy } from '@/i18n/drives-copy';
import { getWorkspaceFilesCopy } from '@/i18n/workspace-files-copy';
import { getWorkspaceNavigationCopy } from '@/i18n/workspace-navigation-copy';
import type { LinkScope } from './types';

export type LinkScopeConfig = { label: string; icon: LucideIcon };

/** Labels and icons for the link scopes, reusing the copy the sidebar,
 * Drive rail and workspace menu already translate. */
export function useLinkScopeConfigs(): Record<LinkScope, LinkScopeConfig> {
  const locale = useLocale();
  const shell = useTranslations('WorkspaceShell');
  return useMemo(() => {
    const drives = getDrivesCopy(locale);
    const files = getWorkspaceFilesCopy(locale);
    return {
      files: { label: drives.myDrive, icon: FolderOpen },
      connectors: { label: shell('connectors'), icon: Cable },
      brands: { label: files.brands, icon: DraftingCompass },
      drives: { label: drives.drives, icon: HardDrive },
      shared: { label: drives.sharedWithMe, icon: Share2 },
      references: { label: shell('myReferences'), icon: Shapes },
      channels: {
        label: getWorkspaceNavigationCopy(locale).inbox,
        icon: MessagesSquare,
      },
      downloads: { label: shell('downloads'), icon: Download },
    };
  }, [locale, shell]);
}
